/*
 * @Author: lbh
 * @Date: 2020-12-24 18:12:01
 * @LastEditors: lbh
 * @LastEditTime: 2025-02-11 14:17:14
 * @Description: 用戶模塊
 */
import axios from "../../util/http";
let origin = axios.host();
let memberWeb = origin + "/member-web/api";
let riceponMember = origin + "/ricepon-member/api";
let riceponCloudGsa = origin + "/ricepon-cloud-gsa/api";
//  獲取消息列表
export const getPushInfoByUser = (params) =>
  axios.post(memberWeb + "/pushInfo/getPushInfoByUser", params);
// 全部已讀
export const readPushInfo = (params) =>
  axios.post(memberWeb + "/pushInfo/readPushInfo", params);

// app - 查詢用戶 優惠券
// export const getMemberCoupon = params =>
//   axios.post(memberWeb + "/member/getMemberCoupon", params);
/**
 * 查詢 用戶 優惠券
 * @param {brandId,memberId,pageIndex=1,pageSize=10,type=2} params
 * @returns
 */
export const getMemberCoupon = (params) =>
  axios.post(`${riceponMember}/member/getMemberCoupon/v2`, params);

// app 兌換 優惠券
export const findCouponByNo = (params) =>
  axios.post(memberWeb + "/coupon/findCouponByNo", params);

// app 查詢用戶 積分
export const pointDetails = (params) =>
  axios.post(memberWeb + "/member/pointDetails", params);

// app 订座列表
export const getReservationList = (params) =>
  axios.post(memberWeb + "/book/getAllBookings2", params);

// app 删除列表
export const removeReservationList = (params) =>
  axios.post(memberWeb + "/book/deleteBooks", params);

// app 最新资讯
export const newMessage = (params) =>
  axios.post(memberWeb + "/advertisement/getNews", params);

// app 最新资讯 更多
export const newMessageDetail = (params) =>
  axios.post(memberWeb + "/advertisement/getNewsMore", params);

// app 意见反馈
export const feedback = (params) =>
  axios.post(memberWeb + "/system/findFeedback", params);

// app 意见反馈详情页
export const feedbackMessage = (params) =>
  axios.post(memberWeb + "/system/getFeedbackLabel", params);

// app 意见反馈提交
export const feedbackSubmit = (params) =>
  axios.post(memberWeb + "/system/addFeedback", params);

/**
 *
 * @param {*} params
 * @returns
 */
export const addFeedback = (params) =>
  axios.form(`${memberWeb}/system/addFeedback`, params);
// app 我的排队列表页、详情
export const lineUp = (params) =>
  axios.post(memberWeb + "/queue/getTickets", params);

// app 我的排队 删除item
export const removeItem = (params) =>
  axios.post(memberWeb + "/queue/deleteCallQueue", params);
// app 排队详情 删除item
export const deleteItem = (params) =>
  axios.post(memberWeb + "/queue/updateStruts", params);

// app 外送專區 輪播圖
export const getSwiper = (params) =>
  axios.get(riceponMember + "/TakeawayArea/getCarousel", params);

// app 外送專區 餐廳列表
export const getRestaurantList = (params) =>
  axios.get(memberWeb + "/TakeawayArea/getPopularRestaurant", params);

// app 外送專區 餐廳列表
export const getRestaurantOrder = (params) =>
  axios.get(riceponMember + "/TakeawayArea/getRestaurantOrder", params);
/**
 * 獲取 oss 上傳 token
 * @param {*} params
 * @returns
 */
export const getSignature = (params) =>
  axios.get(`${riceponMember}/public/aliOss/getSignature`, params);
/**
 * oss 上傳
 * @param {*} url
 * @param {*} params
 * @returns
 */
export const ossUploadImg = (url, params) => axios.upload(url, params);

// H5 叫號首頁
export const getCallNumber = (params) =>
  axios.get(riceponCloudGsa + "/public/getNumber/autoGetNumber", params);

// H5 叫號
export const getNum = (params) =>
  axios.body(riceponCloudGsa + "/public/getNumber/getNum", params);

// H5 叫號詳情
export const getByNumId = (params) =>
  axios.get(riceponCloudGsa + "/public/getNumber/getByNumId", params);

// H5 叫號詳情
export const updateNumberStatus = (params) =>
  axios.body(riceponCloudGsa + "/public/getNumber/updateNumberStatus", params);

// H5 是否開啟叫號
export const getNumberOpen = (params) =>
  axios.get(riceponCloudGsa + "/public/getNumber/getNumberOpen", params);

// 自助碼獲取用戶等級
export const getMemberInfoOth1 = (params) =>
  axios.post(riceponMember + "/member/getMemberInfoOth1", params);

// 叫號登錄歸納
export const bindMemberId = (params) =>
  axios.body(riceponCloudGsa + "/public/getNumber/bindMemberId", params);

// 獲取叫號id
export const distinct = (params) =>
  axios.post(riceponCloudGsa + "/public/getNumber/distinct", params);

// 叫號輪播廣告
export const findAdvertInfo = (params) =>
  axios.post(riceponMember + "/memberAdvert/findAdvertInfo", params);

// 獲取叫號設置
export const getCallSetting = (params) =>
  axios.get(
    riceponCloudGsa + "/public/CallNumberSettings/getByRestaurantId",
    params
  );

// H5文字圖片廣告公告列表
export const adText = (params) =>
  axios.get(riceponCloudGsa + "/public/notice/list", params);
/**
 * * H5登录用户取号历史记录
 * * http://gingersoft.tpddns.cn:53000/project/49/interface/api/10520
 * @param {
 *  restaurantId 是
 *  memberId 是
 *  pageIndex 否 0
 *  pageSize 否 20
 * } params
 * @returns
 */
export const getNumberHistory = (params) =>
  axios.get(`${riceponCloudGsa}/public/getNumber/history`, params);

export const getUserGrade = (params) =>
  axios.get(`${riceponMember}/memberType/memberType`, params);

export const waitFor = (params) =>
  axios.body(`${riceponCloudGsa}/getNumber/priorityWait`, params);

/**
 * 校驗叫號是否超出最大限制數量
 * @param {
 * memberId
 * brandId
 * restaurantId
 * } params
 * @returns
 */
export const whetherTheNumberExceeds = (params) =>
  axios.post(
    `${riceponCloudGsa}/public/getNumber/whetherTheNumberExceeds`,
    params
  );

/**
 * 獲取滿足條件可使用的優惠券數量
 * @param {
 *  brandId     品牌ID
 *  memberId   會員ID
 *  usageType  優惠券使用類型：1 不限制，2 外送，3 gspos，4 自取，5 冷鏈，6 固定碼
 *  orderAmount  訂單金額
 * } params
 * @returns
 */
export const getAvailableCouponQuantity = (params) =>
  axios.get(
    `${riceponMember}/member/memberCoupon/getAvailableCouponQuantity`,
    params
  );

/**
 * * 獲取會員在當前品牌下的會員狀態
 * http://gingersoft.tpddns.cn:53000/project/10/interface/api/10910
 * @param {
 *  brandId 品牌id
 *  memberId 會員id
 * } params
 * @returns
 */
export const getMemberWalletStatusByBrandId = (params) =>
  axios.get(
    `${riceponMember}/memberWallet/getMemberWalletStatusByBrandId`,
    params
  );

/**
 * H5取號選擇隊列時段
 * @param {
 *  brandId
 *  restaurantId
 * } params
 * @returns
 */
export const selectQueuePeriod = (params) =>
  axios.get(`${riceponCloudGsa}/public/getNumber/selectQueuePeriod`, params);

/**
 * * 查詢會員等級信息
 * @param {memberId,brandId} params
 * @returns {
 *  id：會員ID
 *  memberTypeId：會員等級ID
 *  brandName：品牌名稱
 *  levelName1：會員等級名稱1
 *  levelName2：會員等級名稱2
 *  levelName3：會員等級名稱3
 *  memberDiscount：會員時段等級折扣比例
 *  memberName：會員名稱
 * }
 */
export const getMemberDiscountInfo = (params) =>
  axios.get(
    `${riceponMember}/public/memberDiscount/getMemberDiscountInfo`,
    params
  );

/**
 * * 修改 用戶信息
 * @param {*} params
 * @returns
 */
export const updateMemberInfo = (params) =>
  axios.post(`${memberWeb}/member/updateMemberInfo`, params);

/**
 * * 判斷當前是否可以取號
 * @param {*} params
 * @returns
 */
export const getMemberLevelQueue = (params) =>
  axios.get(`${riceponMember}/memberPoints/getMemberLevelQueue`, params);

/**
 * ? oss 上傳
 * @param {*} file
 * @param {*} params
 * @returns
 */
export const ossUpload = (file) => {
  return new Promise((resolve, reject) => {
    getSignature().then((res) => {
      if (res.success) {
        let policyData = res.data;
        let ossUrl = policyData.host;
        let name = file.name || "";
        if (name) {
          name = file.name.split(".")[1];
        } else {
          name = ".png";
        }
        let accessUrl = policyData.dir + "/" + Date.now() + name; //上傳路徑
        let sendData = new FormData();
        sendData.append("OSSAccessKeyId", policyData["accessKeyId"]);
        sendData.append("policy", policyData["encodedPolicy"]);
        sendData.append("Signature", policyData["postSignature"]);
        sendData.append("keys", policyData["dir"]);
        sendData.append("key", accessUrl); //上传的文件路径
        sendData.append("success_action_status", 200); // 指定返回的状态码
        sendData.append("type", "image/*");
        sendData.append("file", file);
        sendData.append("configType", "ossFile");

        // 開始上傳
        axios
          .upload(ossUrl, sendData)
          .then((res) => {
            // 成功后没有回调， 只要觸發了 then , 就默認為成功
            let file = ossUrl + "/" + accessUrl; //获得到的url需要将其存数据库中
            resolve({
              success: true,
              data: file,
            });
          })
          .catch((e) => {
            resolve({
              success: false,
            });
          });
      }
    });
  });
};

/**
 * ? 查詢 用戶是否加入了品牌
 * @param {*} params
 * @returns
 */
export const getMemberBrandId = (params) =>
  axios.get(`${riceponMember}/member/getMemberBrandId`, params);
